// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3b4uh","footer":"ModalFilter_footer__1szjM"};